var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 151 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1501",
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5260",
    "data-name": "Group 5260",
    transform: "translate(-584.5 -334.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 584.5, 334.5)",
    filter: "url(#Rectangle_1501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1501-2",
    "data-name": "Rectangle 1501",
    width: 76,
    height: 76,
    rx: 10,
    transform: "translate(37.5 33.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button",
    transform: "translate(639 382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    d: "M2.894,50.164A17.388,17.388,0,0,0,10.3,64.414a1.436,1.436,0,0,1,.073,2.305l-.021.017a1.431,1.431,0,0,1-1.705.054A20.28,20.28,0,0,1,0,50.164a20.507,20.507,0,0,1,20.361-20.3v2.895A17.611,17.611,0,0,0,2.894,50.164Zm0,0",
    transform: "translate(0 -27.187)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    d: "M225.427.087l5.319,3.638a.491.491,0,0,1,0,.81l-5.319,3.638a.491.491,0,0,1-.768-.4V.492a.491.491,0,0,1,.768-.405Zm0,0",
    transform: "translate(-204.535 0)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    "data-name": "Path 4263",
    d: "M248.015,83.935a17.388,17.388,0,0,0-7.408-14.251,1.436,1.436,0,0,1-.073-2.305l.021-.017a1.431,1.431,0,0,1,1.705-.053,20.279,20.279,0,0,1,8.648,16.626,20.493,20.493,0,0,1-20.346,20.3v-2.895a17.6,17.6,0,0,0,17.452-17.406Zm0,0",
    transform: "translate(-209.909 -61.046)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    "data-name": "Path 4264",
    d: "M168.234,427.972l-5.319-3.638a.491.491,0,0,1,0-.81l5.319-3.638a.491.491,0,0,1,.768.4v7.276A.491.491,0,0,1,168.234,427.972Zm0,0",
    transform: "translate(-148.126 -382.193)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    "data-name": "Path 4265",
    d: "M137.618,189.267l-8.712,7.225-2.2,1.822a2.874,2.874,0,0,1-4.134-.488l-3.388-4.516a2.31,2.31,0,1,1,3.7-2.772l2.287,3.05.019-.015,9.48-7.862a2.31,2.31,0,0,1,2.949,3.557Zm0,0",
    transform: "translate(-108.089 -168.59)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    "data-name": "Path 4266",
    d: "M203.312,189.267l-8.712,7.225a11.7,11.7,0,0,1-3.717-2.92l9.48-7.862a2.31,2.31,0,1,1,2.949,3.557Zm0,0",
    transform: "translate(-173.783 -168.59)",
    fill: "#b1b1b1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateGroup);
export default __webpack_public_path__ + "static/media/update-group.6dcf69112d656a5064b2a1f093a6087b.svg";
export { ForwardRef as ReactComponent };